import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import {
  selectFeature,
  selectFeatureById
} from "~/store/features/featuresActions";
import { withTitle } from "~/components/common/molecules/TitleHelmet";

const ChooseFeature = Loadable({
  loader: () =>
    import(/* desktop */ "~/components/desktop/pages/ChooseFeatureBooking"),
  loading: LoadableLoading,
  delay: 10
});

class ChooseFeatureBooking extends Component {
  methods = {
    handleChooseFeature: item => {
      this.props.selectFeature(item.type);
      this.props.selectFeatureById(item.id);
    },
    handleGoBack: () => {
      const { history } = this.props;
      if (history && history.length > 1) {
        history.goBack();
      } else {
        history.push("/chon-benh-vien");
      }
    }
  };

  render() {
    return (
      <Fragment>
        <ChooseFeature {...this.props} {...this.methods} />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    user: { IsAuthenticated },
    features: {
      allFeatures: { list: listFeatures, loading }
    }
  } = state;
  return {
    device: type,
    listFeatures,
    loading,
    IsAuthenticated
  };
};

const ChooseFeatureBookingHelmet = withTitle({
  component: ChooseFeatureBooking,
  title: "Medpro | Chọn hình thức đăt khám"
});

export default withRouter(
  connect(mapStateToProps, {
    selectFeature,
    selectFeatureById: selectFeatureById
  })(ChooseFeatureBookingHelmet)
);
